import { useNavigate } from "react-router-dom";
import ReportingSemiCircleChartCard from "./ReportingSemiCircleChartCard";
import SectionTitle from "../SectionTitle";
import { appPaths } from "../../Routes";
import { colourToRgb, PCAFScoreToRgb } from "../../constants";

type ReportingScopeSectionProps = {
    notMaterialEmissionsSourcesCount: number;
    reportedVerifiedEmissionsSourcesCount: number;
    reportedUnverifiedEmissionsSourcesCount: number;
    measuredProductionEmissionsSourcesCount: number;
    measuredElectricityEmissionsSourcesCount: number;
    estimatedFromSectorATREmissionsSourcesCount: number;
    estimatedFromCompanyRevenueEmissionsSourcesCount: number;
    estimatedFromAssetValueCountEmissionsSourcesCount: number;
};

const ReportingScopeSection = ({
    notMaterialEmissionsSourcesCount,
    reportedVerifiedEmissionsSourcesCount,
    reportedUnverifiedEmissionsSourcesCount,
    measuredProductionEmissionsSourcesCount,
    measuredElectricityEmissionsSourcesCount,
    estimatedFromSectorATREmissionsSourcesCount,
    estimatedFromCompanyRevenueEmissionsSourcesCount,
    estimatedFromAssetValueCountEmissionsSourcesCount,
}: ReportingScopeSectionProps) => {
    const navigate = useNavigate();

    const materialityReportingChartData = [
        {
            name: "1",
            value: reportedVerifiedEmissionsSourcesCount,
            color: PCAFScoreToRgb[1],
            queryParam: 1,
        },
        {
            name: "2",
            value:
                reportedUnverifiedEmissionsSourcesCount +
                measuredElectricityEmissionsSourcesCount,
            color: PCAFScoreToRgb[2],
            queryParam: "2,3",
        },
        {
            name: "3",
            value: measuredProductionEmissionsSourcesCount,
            color: PCAFScoreToRgb[3],
            queryParam: 4,
        },
        {
            name: "4",
            value: estimatedFromCompanyRevenueEmissionsSourcesCount,
            color: PCAFScoreToRgb[4],
            queryParam: 5,
        },
        {
            name: "5",
            value:
                estimatedFromAssetValueCountEmissionsSourcesCount +
                estimatedFromSectorATREmissionsSourcesCount,
            color: PCAFScoreToRgb[5],
            queryParam: "6,7",
        },
    ];

    const consumptionDataStatusChartData = [
        {
            name: "Reported",
            value:
                reportedVerifiedEmissionsSourcesCount +
                reportedUnverifiedEmissionsSourcesCount,
            color: colourToRgb["green"],
            queryParam: "1,2",
        },
        {
            name: "Measured",
            value:
                measuredElectricityEmissionsSourcesCount +
                measuredProductionEmissionsSourcesCount,
            color: colourToRgb["amber"],
            queryParam: "3,4",
        },
        {
            name: "Estimated",
            value:
                estimatedFromCompanyRevenueEmissionsSourcesCount +
                estimatedFromAssetValueCountEmissionsSourcesCount +
                estimatedFromSectorATREmissionsSourcesCount,
            color: colourToRgb["red"],
            queryParam: "5,6,7",
        },
    ];

    return (
        <>
            <SectionTitle title="Data Quality" noSeperator />
            <div className="flex flex-col gap-6 lg:grid lg:grid-cols-2">
                <ReportingSemiCircleChartCard
                    title="PCAF Scores"
                    data={materialityReportingChartData}
                    onSectorClick={(data) =>
                        navigate(
                            `${appPaths.emissionsSources()}?dataStatusEs=${
                                data.queryParam
                            }`
                        )
                    }
                />
                <ReportingSemiCircleChartCard
                    title="Data Collection Types"
                    data={consumptionDataStatusChartData}
                    onSectorClick={(data) =>
                        navigate(
                            `${appPaths.emissionsSources()}?dataStatusEs=${
                                data.queryParam
                            }`
                        )
                    }
                />
            </div>
        </>
    );
};

export default ReportingScopeSection;
